<template>
  <div class="dbmng-test">
    <div class="container-fluid">
      <div class="row">
        <!-- Header -->
        <div class="col-12 mb-4">
          <h2><i class="fas fa-code me-2"></i>Test Componente DBMng Form</h2>
          <p class="text-muted">Interfaccia di test per la componente dinamica di generazione form</p>
        </div>

      
        <!-- Configurazione Schema -->
        <div class="col-md-6 mb-4">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <i class="fas fa-cog me-2"></i>Schema DBMng
              </h5>
              <div class="btn-group">
                <button class="btn btn-sm btn-outline-primary" @click="loadExampleSchema('basic')">
                  <i class="fas fa-file me-1"></i>Basic
                </button>
                <button class="btn btn-sm btn-outline-success" @click="loadExampleSchema('complete')">
                  <i class="fas fa-star me-1"></i>Complete
                </button>
                <button class="btn btn-sm btn-outline-info" @click="loadExampleSchema('project')">
                  <i class="fas fa-project-diagram me-1"></i>Project
                </button>
                <button class="btn btn-sm btn-outline-warning" @click="loadExampleSchema('array')">
                  <i class="fas fa-list me-1"></i>Array Format
                </button>
                <button class="btn btn-sm btn-outline-dark" @click="loadExampleSchema('layout')">
                  <i class="fas fa-th me-1"></i>Layout Grid
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <label class="form-label">Schema JSON:</label>
                <textarea
                  v-model="schemaText"
                  class="form-control font-monospace"
                  rows="20"
                  placeholder="Inserisci lo schema DBMng in formato JSON..."
                  @input="updateSchema"
                ></textarea>
              </div>
              
              <div class="d-flex gap-2">
                <button class="btn btn-primary" @click="validateAndApplySchema">
                  <i class="fas fa-check me-2"></i>Applica Schema
                </button>
                <button class="btn btn-outline-secondary" @click="formatSchema">
                  <i class="fas fa-indent me-2"></i>Formatta
                </button>
                <button class="btn btn-outline-danger" @click="clearSchema">
                  <i class="fas fa-trash me-2"></i>Pulisci
                </button>
              </div>
              
              <!-- Errori Schema -->
              <div v-if="schemaError" class="alert alert-danger mt-3">
                <strong>Errore Schema:</strong> {{ schemaError }}
              </div>
              
              <!-- Info Schema -->
              <div v-if="parsedSchema.fields" class="alert alert-success mt-3">
                <strong>Schema Valido:</strong> {{ getFieldsCount() }} campi riconosciuti
              </div>
            </div>
          </div>
        </div>

        <!-- Form Generato -->
        <div class="col-md-6 mb-4">
          <div class="card h-100">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <i class="fas fa-wpforms me-2"></i>Form Generato
              </h5>
              <div class="badge" :class="formValidBadgeClass">
                <i class="fas" :class="formValid ? 'fa-check' : 'fa-exclamation-triangle'"></i>
                {{ formValid ? 'Valido' : 'Errori' }}
              </div>
            </div>
            <div class="card-body">
              <!-- Componente DBMng Form -->
              <DbmngForm
                v-if="parsedSchema.fields"
                v-model="formData"
                :dbmng-schema="parsedSchema"
                :show-actions="true"
                submit-label="Test Submit"
                @submit="onFormSubmit"
                @validate="onFormValidate"
              />
              
              <!-- Messaggio se schema vuoto -->
              <div v-else class="text-center text-muted py-5">
                <i class="fas fa-code fa-3x mb-3"></i>
                <p>Configura uno schema DBMng per vedere il form</p>
                <p class="small">Usa i pulsanti "Basic", "Complete" o "Project" per esempi predefiniti</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Dati Form -->
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                <i class="fas fa-database me-2"></i>Dati Form (Output)
              </h5>
              <div class="btn-group">
                <button class="btn btn-sm btn-outline-primary" @click="copyToClipboard(dataText)">
                  <i class="fas fa-copy me-1"></i>Copia
                </button>
                <button class="btn btn-sm btn-outline-secondary" @click="clearData">
                  <i class="fas fa-eraser me-1"></i>Pulisci Dati
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <label class="form-label">Dati JSON Grezzi:</label>
                  <textarea
                    v-model="dataText"
                    class="form-control font-monospace"
                    rows="10"
                    readonly
                    placeholder="I dati del form appariranno qui..."
                  ></textarea>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Informazioni Debug:</label>
                  <textarea
                    :value="debugInfo"
                    class="form-control font-monospace"
                    rows="10"
                    readonly
                    placeholder="Informazioni di debug..."
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast per notifiche -->
    <div class="toast-container position-fixed bottom-0 end-0 p-3">
      <div v-if="showToast" class="toast show" role="alert">
        <div class="toast-header">
          <i class="fas fa-info-circle text-primary me-2"></i>
          <strong class="me-auto">DBMng Test</strong>
          <button type="button" class="btn-close" @click="showToast = false"></button>
        </div>
        <div class="toast-body">
          {{ toastMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DbmngForm from '@/lib/DbmngForm.vue'

export default {
  name: 'DbmngTest',
  components: {
    DbmngForm
  },
  
  data() {
    return {
      schemaText: '',
      parsedSchema: { fields: {} },
      schemaError: null,
      formData: {},
      formValid: true,
      formErrors: [],
      showToast: false,
      toastMessage: ''
    }
  },
  
  computed: {
    dataText() {
      return JSON.stringify(this.formData, null, 2)
    },
    
    debugInfo() {
      const info = {
        schema_valid: !this.schemaError,
        form_valid: this.formValid,
        fields_count: this.getFieldsCount(),
        fields_format: Array.isArray(this.parsedSchema.fields) ? 'array' : 'object',
        data_fields: Object.keys(this.formData).length,
        errors: this.formErrors
        // Rimosso timestamp per evitare ricorsioni infinite
      }
      return JSON.stringify(info, null, 2)
    },
    
    formValidBadgeClass() {
      return this.formValid ? 'bg-success' : 'bg-danger'
    }
  },
  
  mounted() {
    // Carica esempio di base all'avvio
    this.loadExampleSchema('basic')
  },
  
  methods: {
    /**
     * Calcola numero di campi nel schema
     */
    getFieldsCount() {
      if (!this.parsedSchema || !this.parsedSchema.fields) {
        return 0
      }
      
      if (Array.isArray(this.parsedSchema.fields)) {
        return this.parsedSchema.fields.length
      }
      
      if (typeof this.parsedSchema.fields === 'object') {
        return Object.keys(this.parsedSchema.fields).length
      }
      
      return 0
    },
    
    /**
     * Carica schema di esempio
     */
    loadExampleSchema(type) {
      const examples = {
        basic: {
          fields: {
            name: {
              label: "Nome",
              type: "varchar",
              widget: "input",
              nullable: 0,
              max_length: 100,
              placeholder: "Inserisci il tuo nome"
            },
            email: {
              label: "Email",
              type: "email",
              widget: "email",
              nullable: 0,
              description: "Email per le comunicazioni"
            },
            age: {
              label: "Età",
              type: "int",
              widget: "number",
              nullable: 1,
              min: 0,
              max: 120
            },
            active: {
              label: "Attivo",
              type: "boolean",
              widget: "checkbox",
              nullable: 1,
              default: true
            }
          }
        },
        
        complete: {
          fields: {
            username: {
              label: "Nome Utente",
              type: "varchar",
              widget: "input",
              nullable: 0,
              max_length: 50,
              description: "Nome utente univoco"
            },
            password: {
              label: "Password",
              type: "varchar",
              widget: "password",
              nullable: 0,
              min_length: 8
            },
            role: {
              label: "Ruolo",
              type: "varchar",
              widget: "select",
              nullable: 0,
              options: [
                { value: "admin", label: "Amministratore" },
                { value: "user", label: "Utente" },
                { value: "guest", label: "Ospite" }
              ]
            },
            birth_date: {
              label: "Data di Nascita",
              type: "date",
              widget: "date",
              nullable: 1,
              max: "2025-11-12"
            },
            bio: {
              label: "Biografia",
              type: "text",
              widget: "textarea",
              nullable: 1,
              max_length: 500,
              rows: 4,
              placeholder: "Racconta qualcosa di te..."
            },
            salary: {
              label: "Stipendio",
              type: "float",
              widget: "number",
              nullable: 1,
              min: 0,
              step: 0.01
            },
            status: {
              label: "Stato",
              type: "varchar",
              widget: "select",
              nullable: 0,
              voc_val: [
                { "active": "Attivo" },
                { "inactive": "Inattivo" },
                { "suspended": "Sospeso" }
              ]
            }
          }
        },
        
        project: {
          fields: {
            project_name: {
              label: "Nome Progetto",
              type: "varchar",
              widget: "input",
              nullable: 0,
              max_length: 255
            },
            budget: {
              label: "Budget",
              type: "float",
              widget: "number",
              nullable: 0,
              min: 0,
              step: 0.01
            },
            data_inizio: {
              label: "Data Inizio",
              type: "date",
              widget: "date",
              nullable: 1
            },
            data_fine: {
              label: "Data Fine",
              type: "date",
              widget: "date",
              nullable: 1
            },
            stato: {
              label: "Stato",
              type: "int",
              widget: "select",
              nullable: 0,
              default: 0,
              voc_val: [
                { "0": "In Corso" },
                { "1": "Chiuso" }
              ]
            },
            descrizione: {
              label: "Descrizione",
              type: "text",
              widget: "textarea",
              nullable: 1,
              max_length: 1000,
              rows: 5
            }
          }
        },
        
        array: {
          fields: [
            {
              field: "name",
              label: "Nome",
              type: "varchar",
              widget: "input",
              nullable: 0,
              max_length: 100,
              placeholder: "Inserisci il tuo nome",
              col: "col-md-6"
            },
            {
              field: "surname",
              label: "Cognome", 
              type: "varchar",
              widget: "input",
              nullable: 0,
              max_length: 100,
              placeholder: "Inserisci il cognome",
              col: "col-md-6"
            },
            {
              field: "email",
              label: "Email",
              type: "email", 
              widget: "email",
              nullable: 0,
              description: "Email per le comunicazioni",
              col: "col-md-8"
            },
            {
              field: "age",
              label: "Età",
              type: "int",
              widget: "number",
              nullable: 1,
              min: 0,
              max: 120,
              col: "col-md-4"
            },
            {
              field: "status",
              label: "Stato",
              type: "varchar",
              widget: "select",
              nullable: 0,
              voc_val: [
                { "active": "Attivo" },
                { "inactive": "Inattivo" },
                { "pending": "In Attesa" }
              ],
              col: "col-md-6"
            },
            {
              field: "priority",
              label: "Priorità",
              type: "varchar",
              widget: "select",
              nullable: 1,
              voc_val: [
                { "low": "Bassa" },
                { "medium": "Media" },
                { "high": "Alta" },
                { "urgent": "Urgente" }
              ],
              col: "col-md-6"
            },
            {
              field: "bio",
              label: "Biografia",
              type: "text",
              widget: "textarea",
              nullable: 1,
              max_length: 500,
              rows: 4,
              placeholder: "Racconta qualcosa di te...",
              col: "col-12"
            },
            {
              field: "newsletter",
              label: "Iscriviti alla newsletter",
              type: "boolean",
              widget: "checkbox",
              nullable: 1,
              default: false,
              col: "col-md-6"
            },
            {
              field: "terms",
              label: "Accetto i termini e condizioni",
              type: "boolean",
              widget: "checkbox",
              nullable: 0,
              col: "col-md-6"
            }
          ]
        },
        
        layout: {
          fields: [
            {
              field: "title",
              label: "Titolo",
              type: "varchar",
              widget: "input",
              nullable: 0,
              max_length: 100,
              col: "col-12",
              class: "fw-bold"
            },
            {
              field: "first_name",
              label: "Nome",
              type: "varchar", 
              widget: "input",
              nullable: 0,
              col: "col-md-4"
            },
            {
              field: "middle_name",
              label: "Secondo Nome",
              type: "varchar",
              widget: "input", 
              nullable: 1,
              col: "col-md-4"
            },
            {
              field: "last_name",
              label: "Cognome",
              type: "varchar",
              widget: "input",
              nullable: 0,
              col: "col-md-4"
            },
            {
              field: "email",
              label: "Email",
              type: "email",
              widget: "email",
              nullable: 0,
              col: "col-lg-8 col-md-6"
            },
            {
              field: "phone",
              label: "Telefono", 
              type: "varchar",
              widget: "input",
              nullable: 1,
              col: "col-lg-4 col-md-6"
            },
            {
              field: "birth_date",
              label: "Data Nascita",
              type: "date",
              widget: "date",
              nullable: 1,
              col: "col-md-3"
            },
            {
              field: "gender",
              label: "Genere",
              type: "varchar",
              widget: "select",
              nullable: 1,
              voc_val: [
                { "M": "Maschile" },
                { "F": "Femminile" },
                { "X": "Non specificato" }
              ],
              col: "col-md-3"
            },
            {
              field: "country",
              label: "Paese",
              type: "varchar",
              widget: "select",
              nullable: 0,
              voc_val: [
                { "IT": "Italia" },
                { "US": "Stati Uniti" },
                { "FR": "Francia" },
                { "DE": "Germania" },
                { "ES": "Spagna" }
              ],
              col: "col-md-3"
            },
            {
              field: "zip_code",
              label: "CAP",
              type: "varchar",
              widget: "input",
              nullable: 1,
              max_length: 10,
              col: "col-md-3"
            },
            {
              field: "address",
              label: "Indirizzo",
              type: "varchar",
              widget: "input",
              nullable: 1,
              max_length: 255,
              col: "col-md-8"
            },
            {
              field: "city",
              label: "Città",
              type: "varchar",
              widget: "input",
              nullable: 1,
              max_length: 100,
              col: "col-md-4"
            },
            {
              field: "notes",
              label: "Note Aggiuntive",
              type: "text",
              widget: "textarea",
              nullable: 1,
              max_length: 1000,
              rows: 3,
              col: "col-12"
            },
            {
              field: "privacy",
              label: "Accetto l'informativa privacy",
              type: "boolean",
              widget: "checkbox",
              nullable: 0,
              col: "col-md-6"
            },
            {
              field: "marketing",
              label: "Accetto comunicazioni marketing",
              type: "boolean",
              widget: "checkbox",
              nullable: 1,
              default: false,
              col: "col-md-6"
            }
          ]
        }
      }
      
      this.schemaText = JSON.stringify(examples[type], null, 2)
      this.validateAndApplySchema()
      this.showNotification(`Caricato schema di esempio: ${type}`)
    },
    
    /**
     * Aggiorna schema dal testo
     */
    updateSchema() {
      // Aggiornamento in tempo reale disabilitato per performance
      // L'utente deve cliccare "Applica Schema"
    },
    
    /**
     * Valida e applica schema
     */
    validateAndApplySchema() {
      try {
        this.schemaError = null
        const parsed = JSON.parse(this.schemaText)
        
        // Validazione schema base
        if (!parsed || typeof parsed !== 'object') {
          throw new Error('Schema deve essere un oggetto JSON')
        }
        
        if (!parsed.fields) {
          throw new Error('Schema deve contenere un campo "fields"')
        }
        
        // Validazione formato fields
        if (Array.isArray(parsed.fields)) {
          // Formato array: ogni oggetto deve avere 'field', 'label', 'type'
          parsed.fields.forEach((field, index) => {
            if (!field.field) {
              throw new Error(`Campo array[${index}] deve avere un attributo "field"`)
            }
            if (!field.label) {
              throw new Error(`Campo "${field.field}" deve avere una label`)
            }
            if (!field.type) {
              throw new Error(`Campo "${field.field}" deve avere un type`)
            }
          })
        } else if (typeof parsed.fields === 'object') {
          // Formato oggetto associativo (attuale)
          Object.keys(parsed.fields).forEach(fieldName => {
            const field = parsed.fields[fieldName]
            if (!field.label) {
              throw new Error(`Campo "${fieldName}" deve avere una label`)
            }
            if (!field.type) {
              throw new Error(`Campo "${fieldName}" deve avere un type`)
            }
          })
        } else {
          throw new Error('Schema "fields" deve essere un oggetto o un array')
        }
        
        this.parsedSchema = parsed
        this.showNotification('Schema applicato con successo!')
        
      } catch (error) {
        this.schemaError = error.message
        this.parsedSchema = { fields: {} }
      }
    },
    
    /**
     * Formatta JSON schema
     */
    formatSchema() {
      try {
        const parsed = JSON.parse(this.schemaText)
        this.schemaText = JSON.stringify(parsed, null, 2)
        this.showNotification('Schema formattato')
      } catch (error) {
        this.showNotification('Errore nella formattazione: JSON non valido')
      }
    },
    
    /**
     * Pulisce schema
     */
    clearSchema() {
      this.schemaText = ''
      this.parsedSchema = { fields: {} }
      this.schemaError = null
      this.formData = {}
    },
    
    /**
     * Pulisce dati form
     */
    clearData() {
      this.formData = {}
      this.showNotification('Dati puliti')
    },
    
    /**
     * Gestisce submit form
     */
    onFormSubmit(data) {
      console.log('Form submitted:', data)
      this.showNotification(`Form inviato con ${Object.keys(data).length} campi`)
    },
    
    /**
     * Gestisce validazione form
     */
    onFormValidate(validation) {
      this.formValid = validation.valid
      this.formErrors = validation.errors
    },
    
    /**
     * Copia testo negli appunti
     */
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text)
        this.showNotification('Copiato negli appunti!')
      } catch (error) {
        this.showNotification('Errore nella copia')
      }
    },
    
    /**
     * Mostra notifica toast
     */
    showNotification(message) {
      this.toastMessage = message
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, 3000)
    }
  }
}
</script>

<style scoped>
.dbmng-test {
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border: none;
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
}

.font-monospace {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75em;
  padding: 0.5em 0.75em;
}

.btn {
  border-radius: 0.375rem;
}

.gap-2 {
  gap: 0.5rem;
}

.toast-container {
  z-index: 1050;
}

.toast {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.175);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* Responsive */
@media (max-width: 768px) {
  .dbmng-test {
    padding: 10px;
  }
  
  .btn-group .btn {
    font-size: 0.875rem;
    padding: 0.25rem 0.5rem;
  }
  
  .card-body {
    padding: 1rem;
  }
}

/* Stile per textarea code */
textarea.form-control {
  resize: vertical;
  line-height: 1.4;
}

textarea.form-control:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

/* Animazione per badge validazione */
.badge {
  transition: all 0.3s ease;
}

/* Animazione per toast */
.toast {
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>